module.exports = __webpack_public_path__ + "static/media/accessories-1.538443c6.jpg";